import React, { Component } from "react";
import ReactDOM from 'react-dom';
import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

/*
 * Custom "star" icon for the toolbar using an Octicon
 * https://octicons.github.io
 */
const CustomButton = () => <span className="octicon octicon-star" />;

/*
 * Event handler to be attached using Quill toolbar module (see line 73)
 * https://quilljs.com/docs/modules/toolbar/
 */
function insertStar() {
  const cursorPosition = this.quill.getSelection().index;
  this.quill.insertText(cursorPosition, "★");
  this.quill.setSelection(cursorPosition + 1);
}

/*
 * Custom toolbar component including insertStar button and dropdowns
 */
 // https://codepen.io/alexkrolick/pen/gmroPj?editors=0010
const CustomToolbar = () => (
  <div id="toolbar">
    { /*}<select className="ql-header" defaultValue={""} onChange={e => e.persist()}>
      <option value="1" />
      <option value="2" />
      <option selected />
    </select>*/ }
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-list" />
    <button className="ql-bullet" />
    <button className="ql-indent" />
    { /*<select className="ql-color">
      <option value="red" />
      <option value="green" />
      <option value="blue" />
      <option value="orange" />
      <option value="violet" />
      <option value="#d0d1d2" />
      <option selected />
    </select>*/ }
    <button className="ql-insertStar">
      <CustomButton />
    </button>
  </div>
);

/* Document: https://github.com/zenoamaro/react-quill */
export default class TextAreaMod extends Component {
    constructor(props) {
        super(props)
        this.state = { text: '', editorHtml: "" };
        //this.handleChange = this.handleChange.bind(this);
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({ text: nextProps.value })
    }
    componentWillMount() {
        var value = this.props.value;
        this.setState({ text: value })
    }

    /*handleChange(html) {
        this.setState({ text: html })
        //this.setState({ editorHtml: html });
        this.props.handletextChange(html);
    }*/

    render() {

        return (
                <div className="text-editor" style={{backgroundColor: "#fff"}}>
                    { /*}<CustomToolbar />*/ }
                    <ReactQuill style       = {{ height: 116, textAlign:"left" }}
                                onChange    = {this.props.handleChange}
                                value       = {this.state.text /*editorHtml*/ }
                                placeholder = {this.props.placeholder}
                                //modules={Editor.modules}
                                //formats={Editor.formats}
                                //theme={"snow"} // pass false to use minimal theme
                    />
                </div>
        )
    }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
 var Editor = {};

Editor.modules = {
  toolbar: {
    container: "#toolbar",
    handlers: {
      insertStar: insertStar
    }
  },
  clipboard: {
    matchVisual: false,
  }
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */

Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color"
];



// WEBPACK FOOTER //
// ./src/components/TextAreaMod.js